import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';


@IonicPage()
@Component({
	selector: 'page-tab-messages',
	templateUrl: 'tab-messages.html',
})
export class TabMessagesPage {
	public days;
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams) {
	}
	
	ionViewDidLoad() {
		this.days=[
			{
				label:'Oggi',
				messages:[{
					time:'08:27',
					image:'http://lorempixel.com/128/128/people/?random=1',
					content:'Ciao non ci sei mai?'
				}]
			},{
				label:'08/10/2017',
				messages:[
					{
						time:'15:30',
						image:'http://lorempixel.com/128/128/people/?random=2',
						content:'Sono passato a trovarti ma non c\'eri, ciao'
					},{
						time:'11:21',
						image:'http://lorempixel.com/128/128/people/?random=3',
						content:'Le ho lasciato un pacco all\'interno 7'
					}
				]
			}
		];
	}
	
}



// WEBPACK FOOTER //
// ./src/pages/tab-messages/tab-messages.ts